import React from 'react';
import { FileModel } from 'services/EpdClient';
import { ImagesUpload } from 'components/v2/images-upload';
import SmartLabel from 'components/v2/labels/SmartLabel';
import { useVersionLogContext } from '../hooks/useVersionLogContext';
import { VersionLogImageRecord } from '../records/VersionLogImageRecord';

const ImageRenderer: React.FC<VersionLogImageRecord> = ({ label, propertyId }) => {
  const { data } = useVersionLogContext();
  const raw = data?.[propertyId];
  const images = (Array.isArray(raw) ? raw : []) as FileModel[];

  if (images.length === 0) {
    return null;
  }

  return (
    <div>
      {label && <SmartLabel label={label} />}
      <ImagesUpload
        name={propertyId}
        images={images}
        onUpload={() => {}}
        onReorder={() => {}}
        onRemove={() => {}}
        disabled
        preferEnabledAppearanceEvenWhenDisabled
      />
    </div>
  );
};

export default ImageRenderer;
